import React from 'react'

const SvgCheckMark = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <rect width="24" height="24" rx="12" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4762 7.53345C18.734 7.79636 18.7298 8.21845 18.4669 8.47621L10.3069 16.4762C10.0476 16.7304 9.63269 16.7304 9.37345 16.4762L5.53345 12.7115C5.27053 12.4537 5.26636 12.0317 5.52411 11.7687C5.78187 11.5058 6.20396 11.5016 6.46688 11.7594L9.84016 15.0666L17.5334 7.52411C17.7964 7.26636 18.2185 7.27053 18.4762 7.53345Z"
      fill="#F6F6F6"
    />
  </svg>
)
export default SvgCheckMark
